import React, { useEffect } from "react"
import { Keyboard, Platform } from "~/ui/primitives"
import Photos from "./photos"
import PhotosH5 from "./photos-h5"

export interface Photo extends Partial<any> {
  filename: string
  type: string // image/[png|jpg|...]
  path: string // 图片路径
  size: number
}
export interface PhotosModelProps {
  selectedPhoto: Photo | null
  setSelectedPhoto: (photo: Photo) => void | undefined
  selectedPhotos: Photo[] | []
  setSelectedPhotos: (photos: Photo[]) => void | undefined
  submitSelectedPhoto: (photo: Photo) => void | undefined
  submitSelectedPhotos: (photos: Photo[]) => void | undefined
}

const PhotosMode: React.FC<PhotosModelProps> = ({
  selectedPhoto,
  setSelectedPhoto,
  selectedPhotos,
  setSelectedPhotos,
  submitSelectedPhoto,
  submitSelectedPhotos,
}) => {
  useEffect(() => {
    Keyboard.dismiss()
  }, [])

  return Platform.OS === "web" ? (
    <PhotosH5
      selectedPhoto={selectedPhoto}
      setSelectedPhoto={setSelectedPhoto}
      selectedPhotos={selectedPhotos}
      setSelectedPhotos={setSelectedPhotos}
      submitSelectedPhoto={submitSelectedPhoto}
      submitSelectedPhotos={submitSelectedPhotos}
    />
  ) : (
    <Photos
      selectedPhoto={selectedPhoto}
      setSelectedPhoto={setSelectedPhoto}
      selectedPhotos={selectedPhotos}
      setSelectedPhotos={setSelectedPhotos}
      submitSelectedPhoto={submitSelectedPhoto}
      submitSelectedPhotos={submitSelectedPhotos}
    />
  )
}

export default PhotosMode
